import { BotonExportarExcel, Group, Table, Tbody, Th, Thead, Tr } from "@/components/ui";
import type { ClaveSat } from "@/lib/types";
import { ClaveSatRow } from "./ClaveSatRow";

export function ClavesSatTable({
  claves,
  obtenerFilas,
}: {
  claves: ClaveSat[];
  /** Trae TODAS las páginas con la búsqueda actual · para el export. */
  obtenerFilas: () => Promise<ClaveSat[]>;
}) {
  return (
    <div className="overflow-x-auto">
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo="claves-sat"
          hoja="Claves SAT"
          obtenerFilas={obtenerFilas}
          columnas={[
            { header: "Clave", value: (c) => c.clave },
            { header: "Descripción", value: (c) => c.descripcion },
          ]}
        />
      </Group>
      <Table verticalSpacing="sm">
        <Thead>
          <Tr>
            <Th>Clave</Th>
            <Th>Descripción</Th>
            <Th />
          </Tr>
        </Thead>
        <Tbody>
          {claves.map((c) => (
            <ClaveSatRow key={c.clave} clave={c} />
          ))}
        </Tbody>
      </Table>
    </div>
  );
}
